import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  public versionDate$ = new Subject();
  public version$ = new Subject();
}
